export function formatNumberToString(resNumber: string | number | null | undefined): string {
  if (!resNumber) return '0';

  return resNumber.toLocaleString('fullwide', {useGrouping:false}).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
